'use client'

import { useLocale, useTranslations } from 'next-intl'
import { Reviews } from '@/shared/components/reviews/reviews'
import { ReassuranceReviews } from '@/shared/components/reviews/reassurance-reviews'
import { highlight } from '@/shared/components/step-title/step-title'

// Ratings of SeDomicilier shown in the subflow, to update by hand
const RATINGS = { trustpilot: 4.5, google: 4.4 }

// Ratings of SeDomicilier and the sentence of trust that precedes them, in the language of the prospect
export const SubflowReviews = ({
  className,
  titleClassName
}: {
  className?: string
  titleClassName?: string
}) => {
  const t = useTranslations('common')
  const locale = useLocale()
  const format = new Intl.NumberFormat(locale, { minimumFractionDigits: 1 })

  return (
    <Reviews
      title={t.rich('trust', { highlight })}
      titleClassName={titleClassName}
      ratings={{
        trustpilot: format.format(RATINGS.trustpilot),
        google: format.format(RATINGS.google)
      }}
      className={className}
    />
  )
}

// Reassurance of the project step above the ratings, the sentence of trust stacked on the ratings
export const ProjectReassurance = ({ className }: { className?: string }) => {
  const t = useTranslations('project')

  return (
    <ReassuranceReviews
      reassurance={t.rich('reassurance', {
        highlight,
        br: () => <br className='md:hidden' />
      })}
      className={className}
    >
      <SubflowReviews className='md:flex-col md:gap-2' />
    </ReassuranceReviews>
  )
}
